/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Search, Filter, Download, ReportMoney, ArrowUpRight, ArrowDownRight,
} from 'tabler-icons-react';
import {
  TextInput, useMantineColorScheme,
} from '@mantine/core';
import {
  Line, LineChart, Pie, PieChart, ResponsiveContainer, XAxis, YAxis, Cell, Tooltip,
} from 'recharts';
import { Card, ConfigProvider } from 'antd';
import { assetPrefix, renderNumber, renderCompactNumber } from '../../../utilities/general';
import CustomSelect from '../../Listing/companyData/Select';
import styles from './PositionsTabV2.module.css';

export default function PositionsTabV2(props) {
  const [searchValue, setSearchValue] = useState('');
  const { colorScheme } = useMantineColorScheme();

  const [selectOptions, setSelectOptions] = useState('All Levels');

  const data = [
    { value: 'All Levels', label: 'All Levels' },
    { value: 'Level 1', label: 'Level 1' },
    { value: 'Level 2', label: 'Level 2' },
    { value: 'Interims', label: 'Interims' },
    { value: 'Remove Dust', label: 'Remove Dust' },
  ];

  const assetData = [
    { name: 'BTC', value: 45, color: '#1A2A50' },
    { name: 'ETH', value: 25, color: '#2B7FFF' },
    { name: 'SOL', value: 15, color: '#9945FF' },
    { name: 'Other', value: 15, color: '#0033AD' },
  ];

  const performanceData = [
    { date: 'Nov 1', amount: 93000 },
    { date: 'Nov 2', amount: 90000 },
    { date: 'Nov 3', amount: 96000 },
    { date: 'Nov 4', amount: 9000 },
    { date: 'Nov 5', amount: 16300 },
    { date: 'Nov 6', amount: 80000 },
  ];

  const positionsData = [
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Binance',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Short',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Kraken',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: 67.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: 234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
    },
  ];

  const amountFormatter = (amount) => renderCompactNumber(amount, amount > 0 && true);

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const { amount } = payload[0].payload;

    return (
      <div className="bg-white text-white dark:bg-[#26282C] px-3 py-2 rounded-xl shadow-xl border border-gray-400">
        <p className="text-xs text-[#58667E] dark:text-[#898989]">{label}</p>
        <p className="text-sm font-semibold text-[#58667E] dark:text-[#BEB9B9]">
          {`Amount: ${renderNumber(amount, true)}`}
        </p>
      </div>
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
            borderRadiusLG: 14,
          },
        },
      }}
    >
      <div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-[#101828] dark:text-white">Open Positions</h1>
            <p className="text-base font-normal text-[#4A5565] dark:text-[#898989]">Monitor and manage your active trading positions</p>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Positions</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                4
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Investment</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                {renderNumber(77630.50, true) || '0.00'}
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Current Value</div>
              <div className="text-2xl font-bold text-[#009966]">
                {renderNumber(80219.05, true) || '0.00'}
              </div>
            </Card>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="flex flex-col p-6 gap-6 w-full col-span-1 bg-white dark:bg-[#26282C] rounded-[14px]">
              <div className="text-lg font-medium text-[#101828] dark:text-[#898989]">
                Asset Allocation
              </div>

              {/* Pie Chart */}
              <div className="w-full h-[220px] flex justify-center items-center shrink-0">
                <ResponsiveContainer width="80%" height="90%">
                  <PieChart>
                    <Pie
                      data={assetData}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={90}
                      paddingAngle={3}
                      dataKey="value"
                      stroke="none"
                    >
                      {assetData.map((entry, index) => (
                        <Cell key={index} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="grid grid-cols-2 gap-2">
                {assetData.map((asset, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <span
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: asset.color }}
                    />
                    <span className="text-sm text-[#4A5565] dark:text-[#898989]">
                      {asset.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col p-6 gap-6 w-full col-span-1 lg:col-span-2 bg-white dark:bg-[#26282C] rounded-[14px]">
              <div className="text-lg font-medium text-[#101828] dark:text-[#898989]">
                Performance
              </div>

              <div className="w-full h-[300px] shrink-0">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={performanceData}
                    margin={{
                      top: 10, right: 20, left: 0, bottom: 0,
                    }}
                  >
                    <XAxis dataKey="date" />
                    <YAxis
                      domain={[0, 100000]}
                      ticks={[0, 25000, 50000, 75000, 100000]}
                      tickFormatter={amountFormatter}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={false} />
                    <Line
                      type="monotone"
                      dataKey="amount"
                      stroke="#2B7FFF"
                      strokeWidth={3}
                      dot={{ r: 6, fill: '#2B7FFF', stroke: 'none' }}
                      activeDot={{ r: 9, fill: '#2B7FFF', stroke: 'none' }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

          </div>

          <div className="flex flex-col items-start gap-[46px] rounded-[14px] bg-white dark:bg-[#26282C] p-6 shadow-md flex-shrink-0 self-stretch">
            <div className="w-full flex justify-between items-center">
              <div className="h-9 flex justify-center items-start gap-4">
                <TextInput
                  classNames={{
                    input: 'bg-[#FAFAFA] dark:bg-[#1a1b1e] dark:border-neutral-600 border-[#E5E7EB]',
                  }}
                  className="w-80"
                  placeholder="Search positions..."
                  radius="md"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.currentTarget.value)}
                  icon={<Search size={16} color="#99A1AF" />}
                />
                <CustomSelect
                  options={data}
                  value={selectOptions}
                  onChange={setSelectOptions}
                  icon={<Filter size={16} color="#717182" />}
                />
              </div>
              <div className={`${styles.padding} border border-[#0000001A] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-lg`}>
                <Download size={16} color={colorScheme === 'dark' ? '#898989' : '#0A0A0A'} />
                <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">Export</span>
              </div>
            </div>
            <div className={`${styles.grid} w-full h-full flex flex-col items-start border border-[#F3F4F6] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-[10px]`}>
              <div className={`w-full h-10 grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 bg-[#F9FAFB80] dark:bg-[#1a1b1e] ${styles.PositionsTabHeadingGrid}`}>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Asset
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Total Investment
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Current Status
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Value of Open Position
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Change
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Direction
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Platform
                </div>
              </div>
              {positionsData.map((items) => (
                <div className={`w-full h-[73px] grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 last:border-none ${styles.PositionsTabRowGrid}`}>
                  <div className="flex items-center gap-3 text-base font-normal">
                    {items?.icon
                      ? (
                        <img
                          className="w-8 h-8 rounded-full"
                          src={items?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                          alt="Crypto"
                        />
                      )
                      : <ReportMoney className="w-11 h-11" />}

                    <div className="flex flex-col gap-1">
                      <span
                        className={`${styles.title} font-semibold text-[#101828] dark:text-[#898989]`}
                      >
                        {items?.asset?.length > 8 ? `${items?.asset?.slice(0, 8)}...` : items?.asset.toUpperCase() || '-'}
                      </span>
                      <span
                        className={`${styles.subTitle}`}
                      >
                        {items?.tradingProductType}
                      </span>
                    </div>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.totalInvestment.assetValue, true)}
                  </div>
                  <div className={`${styles.title} font-medium ${items?.runningPnL.assetValue > 0 ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                    <div className="flex items-center gap-1">
                      {items?.runningPnL.assetValue > 0 ? (
                        <ArrowUpRight size={16} className="text-[#009966]" />
                      ) : (
                        <ArrowDownRight size={16} className="text-[#FB2C36]" />
                      )}
                      <span>{renderNumber(items?.runningPnL.assetValue, true)}</span>
                    </div>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.valueOpenPositions, true)}
                  </div>
                  <div className={`${styles.title} flex items-center gap-1 font-medium ${items?.change.percentage > 0 ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                    {items?.change.percentage > 0 ? (
                      <ArrowUpRight size={12} className="text-[#009966]" />
                    ) : (
                      <ArrowDownRight size={12} className="text-[#FB2C36]" />
                    )}
                    <span>{`${renderNumber(items?.change.percentage)}%`}</span>
                  </div>
                  <div className={`w-fit text-xs font-medium px-2 py-[3px] rounded-lg ${items?.direction === 'Long' ? 'bg-[#030213] text-white' : 'bg-[#ECEEF2] text-[#030213]'}`}>
                    {items?.direction}
                  </div>
                  <div className="w-fit py-1 px-2 text-xs bg-[#F9FAFB] rounded-lg border border-[#0000001A] font-medium text-[#0A0A0A]">
                    {items.platform}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
